import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

// core components
import Admin from "layouts/Admin.js";
import SignInSide from "./views/SignInSide/SignInSide";
import Centrofarma from "./views/SignInSide/Centrofarma";
import RegisterSide from "./views/SignInSide/RegisterSide";
import MapsPage from "./views/Maps/Maps";
import LockersPage from "./views/Lockers/Lockers";
import UsersPage from './views/Usuarios/index'

import "assets/css/material-dashboard-react.css?v=1.8.0";


const hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      {/* <Route path="/signUp" component={RegisterSide} /> */}
      <Route path="/admin" component={Admin} />

      {/* <Route path="/login/centrofarma" component={Centrofarma} /> */}
      <Route path="/signIn" component={SignInSide} />

      <Redirect
        from="/geo"
        to={localStorage.getItem("geo") ? "/admin/maps" : "/admin/lockers"}
      />


      <Redirect
        from="*"
        to={localStorage.getItem("user") ? "/admin/lockers" : "/signIn"}
      />
    </Switch>
  </Router>,
  document.getElementById("root")
);
